import styled from "styled-components";
import { Link } from "react-router-dom";

export const CategoryPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;

  @media screen and (max-width: 792px) {
    align-item: center;

  }
`;

export const Title = styled(Link)`
  font-size: 28px;
  margin-bottom: 25px;
  cursor: pointer;
`;

export const Preview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
justify-items: space-between;


  @media screen and (max-width: 792px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 30px;
  }

  @media screen and (max-width: 400px) {
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 30px;
  }
`;
